import { render, staticRenderFns } from "./ProcessPage.vue?vue&type=template&id=2b305caa&scoped=true&"
import script from "./ProcessPage.vue?vue&type=script&lang=js&"
export * from "./ProcessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b305caa",
  null
  
)

export default component.exports